import React from "react";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { getSanitizedDescriptionAlt } from "@companion-core/shared/app/Utils/componentHelper";
import { Carousel } from "@companion-core/shared/app/Components/Carousel";
import { ImageSliderProps } from ".";
import "@companion-core/web/src/Assets/Styles/scss/imageSlider.scss";

export const ImageSlider = ({ images }: ImageSliderProps) => {
  return (
    <div className="image-slider" data-testid="image-slider">
      <Carousel autoplay={false} hasMultipleImages={images.length > 1}>
        {images?.map((value, key) => (
          <div key={key} className="image-container">
            <img
              src={getCloudinaryOptimizedUrl(value.url, {
                contentType: "banner",
                width: window.innerWidth,
              })}
              className="slide-img"
              alt={getSanitizedDescriptionAlt(value?.description_alt) ?? ""}
              data-testid={`slide-image-${key}`}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
